/**
 * 获取显示文案
 * @param item
 * @param dataLanguage
 * @returns
 */
export function getDisplayName(item, dataLanguage) {
  if (item === void 0) {
    item = {};
  }
  var _item = item,
    _item$names = _item.names,
    names = _item$names === void 0 ? {} : _item$names,
    language = _item.language;
  if (dataLanguage === 'local') {
    return names[language];
  } else {
    if (names[dataLanguage]) {
      return names[dataLanguage];
    } else if (names['EN']) {
      return names['EN'];
    } else {
      return names[language];
    }
  }
}